import script from "./ScriptPhoneStep.vue?vue&type=script&lang=ts&setup=true"
export * from "./ScriptPhoneStep.vue?vue&type=script&lang=ts&setup=true"

import "./ScriptPhoneStep.vue?vue&type=style&index=0&id=42b5fb38&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42b5fb38"]])

export default __exports__